import badgeIcon from '@/icons/badge-icon.svg';
import circleShippingIcon from '@/icons/circle-shipping-icon.svg';
import usaFlagIcon from '@/icons/usa-flag-round-icon.svg';

export const valueProps = [
  {
    icon: {
      url: badgeIcon,
      alt: 'Badge Icon',
    },
    title: '100% Risk Free',
    subtitle: 'Money Back Guarantee',
  },
  {
    icon: {
      url: usaFlagIcon,
      alt: 'USA Flag Icon',
    },
    title: 'USA Lab Tested',
    subtitle: 'Guaranteed Safe',
  },
  {
    icon: {
      url: circleShippingIcon,
      alt: 'Shipping Icon',
    },
    title: 'FREE Shipping from Oregon',
    subtitle: 'Ships in 3-5 Days',
  },
];

export default function IconValueProps({valueProps}: IconValuePropsProps) {
  return (
    <div className="grid grid-cols-[auto,max-content,auto,max-content,auto] gap-3">
      {valueProps.map((valueProp, index) => (
        <>
          {index % 3 > 0 && (
            <div className="h-full w-0 border-l border-deep-ocean-blue/70"></div>
          )}
          <div className="flex flex-col items-center gap-y-1 text-center">
            <img
              src={valueProp.icon.url}
              alt={valueProp.icon.alt}
              className="size-4.5"
            />
            <span className="text-sm font-semibold">{valueProp.title}</span>
            <span className="text-xs text-deep-ocean-blue/70">
              {valueProp.subtitle}
            </span>
          </div>
        </>
      ))}
    </div>
  );
}

export type IconValuePropsProps = {
  valueProps: ValueProp[];
};

export type ValueProp = {
  title: string;
  subtitle: string;
  icon: {
    url: string;
    alt: string;
  };
};
